import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 객체의 모든 파라미터를 문자열로 변환하는 함수
 * @param params 변환할 파라미터 객체
 * @returns 문자열로 변환된 파라미터 객체
 */
export function stringifyParams<T extends Record<string, any>>(params: T): Record<string, string> {
  const stringParams: Record<string, string> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      stringParams[key] = String(value);
    }
  });
  return stringParams;
}